export const colors = {
    grey50: "#F9FAFB",
    grey100: "#F4F7F9",
    grey200: "#EAECF0",
    grey300: "#D0D5DD",
    grey700: "#344054",
    black: "#000000"
}